import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeMetodePenyusutanService = new CrudCustom('/tipe-metode-penyusutans');
export default TipeMetodePenyusutanService;
